"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1757],{

/***/ 89777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85827);
/* harmony import */ var _components_icons_Close__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24162);
/* harmony import */ var _components_ui_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58262);
/* harmony import */ var _features_livestream_detail_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77910);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7806);
/* harmony import */ var _libs_app__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92517);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65820);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15331);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74931);












var SearchPartial = function(param) {
    var t = param.t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]), dataSearchKey = ref[0], setDataSearchKey = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var ref2 = (0,_features_livestream_detail_api__WEBPACK_IMPORTED_MODULE_4__/* .useFetchLiveVideosQuery */ .fN)({
        product_keyword: keyword
    }, {
        enabled: false,
        retry: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast__WEBPACK_IMPORTED_MODULE_8__/* ["default"].error */ .ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            var _data = [];
            _data = data.map(function(d) {
                var _d = {};
                var productData = d.live_stream_product.find(function(p) {
                    return p.products.product_code.toLocaleLowerCase() === keyword.toLocaleLowerCase();
                });
                _d = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, productData), {
                    link: d.link,
                    live_stream: {
                        images: d.images,
                        name: d.live_streamer.name,
                        id: d.id + "",
                        title: d.name,
                        duration: d.duration
                    }
                });
                return _d;
            });
            if (keyword) {
                setDataSearchKey(Array.isArray(_data) ? _data : []);
            }
        }
    }), refetchKeyword = ref2.refetch, loadingSearch = ref2.isLoading;
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (keyword !== "") {
            refetchKeyword();
        } else {
            setDataSearchKey([]);
        }
    }, [
        keyword,
        refetchKeyword
    ]);
    var handleChange = function(value) {
        setKeyword(value);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var optimizedFn = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)((0,_libs_app__WEBPACK_IMPORTED_MODULE_6__/* .debounce */ .Ds)(handleChange, 300), []);
    var clearInput = function() {
        if (inputRef.current) {
            inputRef.current.value = "";
            setKeyword("");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-w-full tw-relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-flex tw-rounded-5 tw-text-secondary-70 tw-border tw-overflow-hidden tw-border-primary-main tw-py-2 tw-px-3 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .J, {
                        className: "tw-w-6 tw-h-6",
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SearchIcon */ .W1, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "text",
                        ref: inputRef,
                        placeholder: t("layout:label.search-keyword"),
                        className: "tw-w-full tw-outline-none tw-ml-2 tw-placeholder-secondary-70 ",
                        onChange: function(e) {
                            return optimizedFn(e.target.value);
                        }
                    }),
                    keyword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "tw-text-primary-main tw-cursor-pointer",
                        onClick: clearInput,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .J, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_Close__WEBPACK_IMPORTED_MODULE_2__/* .CloseIcon */ .T, {}),
                            className: "tw-w-6 tw-h-6"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .AnimatePresence */ .M, {
                children: keyword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_12__/* .motion.div */ .E.div, {
                    className: "tw-absolute tw-drop-shadow tw-px-2 md:tw-px-4 tw-py-2 tw-left-0 tw-z-10 tw-bg-white tw-rounded-5 top-full-8 tw-w-full",
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: 0.4
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-w-full tw-h-full tw-overflow-y-scroll tw-max-h-80",
                        children: loadingSearch ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Loading */ .gb, {}) : !dataSearchKey.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-py-10 tw-text-center",
                            children: "Kh\xf4ng t\xecm thấy video"
                        }) : dataSearchKey.map(function(data) {
                            var id = data.live_stream.id;
                            var handle = "".concat((0,_libs_app__WEBPACK_IMPORTED_MODULE_6__/* .createHandle */ .UR)(data.live_stream.title), "-").concat(id);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-py-2 tw-border-b",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "tw-w-full md:tw-w-2/3",
                                    onClick: function() {
                                        return clearInput();
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                        url: {
                                            pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_5__/* .PagePath.LiveVideoPage */ ._.LiveVideoPage,
                                            query: {
                                                id: handle,
                                                start: data.played
                                            }
                                        },
                                        className: "tw-w-full",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-py-2 tw-px-4 tw-rounded-5",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .LiveProduct */ .SK, {
                                                data: data
                                            })
                                        })
                                    })
                                })
                            }, "live" + id);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_7__.memo)(SearchPartial));


/***/ }),

/***/ 98346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UC": function() { return /* binding */ PinnedProductDefault; },
/* harmony export */   "Ww": function() { return /* binding */ FormChatDefault; },
/* harmony export */   "i1": function() { return /* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_0__.i; },
/* harmony export */   "zN": function() { return /* binding */ LiveStreamStatus; }
/* harmony export */ });
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11444);


var LiveStreamStatus = {
    LIVE_NOW: "LIVE_NOW",
    UNPUBLISHED: "UNPUBLISHED",
    SCHEDULED_LIVE: "SCHEDULED_LIVE",
    SCHEDULED_CANCELED: "SCHEDULED_CANCELED",
    SCHEDULED_UNPUBLISHED: "SCHEDULED_UNPUBLISHED",
    VOD: "VOD",
    LIVE: "LIVE"
};
/**
 * Default !value
 */ var FormChatDefault = {
    comment: ""
};
var PinnedProductDefault = null;


/***/ }),

/***/ 6501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _const__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98346);
/* harmony import */ var _libs_app__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92517);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7806);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85827);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77910);
/* harmony import */ var _features_products_detail_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17852);
/* harmony import */ var _features_consults_chat_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96732);
/* harmony import */ var _libs_cookies__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47279);










var Products = function(param) {
    var onClose = param.onClose, liveId = param.liveId, t = param.t, userId = param.userId, sendComment = param.sendComment;
    var isAuth = (0,_libs_cookies__WEBPACK_IMPORTED_MODULE_9__/* .getAuth */ .v0)().isAuth;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), products = ref[0], setProducts = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), p = ref1[0], setP = ref1[1];
    var refetch = (0,_api__WEBPACK_IMPORTED_MODULE_6__/* .useFetchProductLiveIdQuery */ .Ov)(liveId, {
        onSuccess: function(param) {
            var data = param.data;
            setProducts(data);
        }
    }).refetch;
    var ref2 = (0,_features_consults_chat_api__WEBPACK_IMPORTED_MODULE_8__/* .useCreateOrderChat */ .qW)({}), sendMessage = ref2.mutate;
    var ref3 = (0,_features_products_detail_api__WEBPACK_IMPORTED_MODULE_7__/* .useFetchConversationByProductQuery */ .uK)((p === null || p === void 0 ? void 0 : p.id) || 0, {
        retry: 0,
        enabled: false,
        onSuccess: function(data) {
            var ref = data.data || {}, id = ref.id, type_code = ref.type_code, type = ref.type;
            sendMessage({
                id: id,
                data: {
                    content: "TV ".concat(type_code),
                    images: [],
                    type: "text"
                }
            });
        },
        onError: function() {
            return mutate({
                title: (p === null || p === void 0 ? void 0 : p.product_name) || "",
                type_id: (p === null || p === void 0 ? void 0 : p.id) || 0,
                type_image: (0,_libs_app__WEBPACK_IMPORTED_MODULE_3__/* .getProductImage */ .C6)(p === null || p === void 0 ? void 0 : p.images) || "",
                type_code: (p === null || p === void 0 ? void 0 : p.product_code) || "",
                type: _const__WEBPACK_IMPORTED_MODULE_2__/* .ConversationType.Product */ .i1.Product
            });
        }
    }), fetchConversation = ref3.refetch, isFetchConversationLoading = ref3.isLoading;
    var ref4 = (0,_api__WEBPACK_IMPORTED_MODULE_6__/* .useCreateChatConversation */ .uJ)({
        onSuccess: function(param) {
            var data = param.data;
            var conversation = data.conversation;
            sendMessage({
                id: conversation.id,
                data: {
                    content: "TV ".concat(conversation.type_code),
                    images: [],
                    type: "text"
                }
            });
        },
        onError: function(param) {
            var message = param.message;
        }
    }), mutate = ref4.mutate, isCreateChatConversationLoading = ref4.isLoading;
    var onConsultClick = function(p) {
        if (p.id) {
            setP(p);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (p === null || p === void 0 ? void 0 : p.id) fetchConversation();
    }, [
        fetchConversation,
        p === null || p === void 0 ? void 0 : p.id
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        refetch();
    }, [
        liveId,
        refetch
    ]);
    var handleSendMessage = function(p) {
        onConsultClick(p);
        sendComment(p.product_code);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-relative tw-w-full tw-h-full tw-flex tw-flex-col tw-rounded-lg tw-bg-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-flex tw-px-3 tw-py-1 tw-border-b tw-items-center tw-justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "tw-text-base tw-font-semibold",
                        children: "Sản phẩm trong Livestream"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-cursor-pointer",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .XNewIcon */ .HW, {}),
                            className: "tw-w-6 tw-h-6"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-mt-2 tw-overflow-y-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: " tw-flex tw-flex-col tw-h-full",
                    children: products.length > 0 ? products.map(function(p, i) {
                        var ref, ref1, ref2, ref3, ref4;
                        var isDiscount = p.product_discount ? (0,_libs_app__WEBPACK_IMPORTED_MODULE_3__/* .checkTime */ .s)((ref = p.product_discount) === null || ref === void 0 ? void 0 : ref.started_at, (ref1 = p.product_discount) === null || ref1 === void 0 ? void 0 : ref1.ended_at) : false;
                        if ((p === null || p === void 0 ? void 0 : p.product_discount) && ((ref2 = p.product_discount) === null || ref2 === void 0 ? void 0 : ref2.status) === _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .DiscountStatus.Ended */ .YT.Ended) isDiscount = false;
                        var isDeposited = p.quantity <= 0 || p.status == _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .ProductStatus.CloseASale */ .Pt.CloseASale || p.status === _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .ProductStatus.Deposited */ .Pt.Deposited;
                        var handle = "".concat((0,_libs_app__WEBPACK_IMPORTED_MODULE_3__/* .createHandle */ .UR)(p.product_name), "-").concat(p.id, "-").concat(p.product_code);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tw-flex tw-gap-2 tw-p-2 ".concat(i < products.length && "tw-border-b"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-w-[54px] tw-h-[54px] tw-relative tw-leading-0 tw-bg-secondary-20 tw-z-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .Ee, {
                                                className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                                                alt: p.product_name,
                                                src: p.images && p.images[0] ? p.images[0].url : "/bg-default.png"
                                            }),
                                            p.product_discount && isDiscount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1 tw-z-10",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .Ee, {
                                                        src: "/sale.png",
                                                        className: "tw-w-full tw-h-full",
                                                        alt: "sale"
                                                    })
                                                })
                                            }),
                                            p.is_auction && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1 tw-z-10",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .Ee, {
                                                        src: "/auction.png",
                                                        className: "tw-w-full tw-h-full",
                                                        alt: "auction"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-flex tw-flex-col tw-flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
                                                url: {
                                                    pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .PagePath.ProductDetailPage */ ._.ProductDetailPage,
                                                    query: {
                                                        id: handle
                                                    }
                                                },
                                                target: "_black",
                                                className: "tw-line-clamp-1 tw-text-primary-main tw-text-xs tw-leading-4 tw-font-bold",
                                                children: p === null || p === void 0 ? void 0 : p.product_name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "",
                                                children: !p.quotation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "tw-text-secondary-70 tw-flex tw-flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "tw-text-xs",
                                                            children: p.product_code
                                                        }),
                                                        p.product_discount && isDiscount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "tw-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "tw-text-warning-90 tw-font-medium tw-text-13",
                                                                    children: (0,_libs_app__WEBPACK_IMPORTED_MODULE_3__/* .toMoney */ .KP)(p.price - p.price * ((ref3 = p.product_discount) === null || ref3 === void 0 ? void 0 : ref3.discount) / 100, t)
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: "\xa0~\xa0"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "tw-text-primary-main tw-font-medium tw-text-13",
                                                                    children: (0,_libs_app__WEBPACK_IMPORTED_MODULE_3__/* .toMoney */ .KP)(p.token - p.token * ((ref4 = p.product_discount) === null || ref4 === void 0 ? void 0 : ref4.discount) / 100, t, _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .PriceSymbol.Atd */ .hb.Atd)
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "tw-flex tw-text-xs tw-items-center lg:tw-gap-x-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "tw-text-warning-90 tw-font-medium tw-text-xs",
                                                                    children: (0,_libs_app__WEBPACK_IMPORTED_MODULE_3__/* .toMoney */ .KP)(p.price, t)
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: "\xa0~\xa0"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "tw-text-primary-main tw-font-medium tw-text-xs",
                                                                    children: (0,_libs_app__WEBPACK_IMPORTED_MODULE_3__/* .toMoney */ .KP)(p.token, t, _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .PriceSymbol.Atd */ .hb.Atd)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "tw-text-secondary-70",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "tw-text-xs",
                                                                children: p.product_code
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "tw-text-warning-90",
                                                                children: t("layout:btn.contact")
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    isAuth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-y-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                                                disabled: !userId || p.quantity <= 0,
                                                onClick: function() {
                                                    return handleSendMessage(p);
                                                },
                                                className: "!tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px] tw-text-xs !tw-rounded-5 tw-py-1 tw-px-3 sm:tw-w-1/2 tw-h-[34px]",
                                                variant: _components__WEBPACK_IMPORTED_MODULE_5__/* .ButtonVariant.Outlined */ .Wu.Outlined,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .ChatLineIcon */ .Ce, {}),
                                                        className: "tw-w-3 tw-h-3 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3"
                                                    }),
                                                    t("layout:btn.consult")
                                                ]
                                            }),
                                            !p.is_auction && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: p.quotation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "tw-w-full tw-flex tw-justify-start tw-mt-6",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                                                            disabled: p.status !== _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .ProductStatus.Availability */ .Pt.Availability,
                                                            onClick: function() {
                                                                return onConsultClick(p);
                                                            },
                                                            className: "tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px] tw-text-xs !tw-rounded-5 tw-py-1 tw-px-3 sm:tw-w-1/2 tw-text-warning-90 tw-border-warning-90 tw-h-[34px]",
                                                            variant: _components__WEBPACK_IMPORTED_MODULE_5__/* .ButtonVariant.Outlined */ .Wu.Outlined,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "tw-flex tw-gap-x-4 tw-justify-center",
                                                                children: "Li\xean hệ"
                                                            })
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: p.quantity <= 0 || p.status != _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .ProductStatus.Availability */ .Pt.Availability ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                                                        disabled: true,
                                                        className: "!tw-rounded-5 tw-text-white tw-bg-primary-main tw-py-1 tw-px-3 tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px] tw-uppercase tw-text-xs",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                                                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .WalletIcon */ .o, {}),
                                                                className: "tw-w-3 tw-h-3 tw-mr-1 tw-text-white"
                                                            }),
                                                            t("layout:btn.deposited")
                                                        ]
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
                                                        url: {
                                                            pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_4__/* .PagePath.ProductDepositPage */ ._.ProductDepositPage,
                                                            query: {
                                                                id: p.id,
                                                                stream_id: liveId
                                                            }
                                                        },
                                                        target: "_blank",
                                                        className: "tw-bg-primary-main !tw-text-white !tw-w-max lg:!tw-w-[125px] tw-gap-x-1 tw-border tw-px-3 tw-py-1 tw-rounded-5 tw-flex tw-items-center tw-justify-center tw-uppercase tw-text-xs ",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                                                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .WalletIcon */ .o, {}),
                                                                className: "tw-w-3 tw-h-3 tw-mr-1 tw-text-white"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: t("layout:btn.order")
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        });
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-py-10 tw-text-lg tw-text-center",
                        children: "Kh\xf4ng c\xf3 sản phẩm"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Products);


/***/ }),

/***/ 21893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ player; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
// EXTERNAL MODULE: ./features/livestream/detail/const.ts
var detail_const = __webpack_require__(98346);
// EXTERNAL MODULE: ./features/livestream/detail/api.ts
var api = __webpack_require__(77910);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 171 modules
var motion = __webpack_require__(15331);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./components/index.ts + 88 modules
var components = __webpack_require__(85827);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js + 4 modules
var FacebookShareButton = __webpack_require__(8136);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
// EXTERNAL MODULE: ./libs/app/index.ts
var app = __webpack_require__(92517);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/player/countdown.tsx



var CountDown = function(param) {
    var endTime = param.endTime, handleCountDown = param.handleCountDown;
    var countDownDate = new Date(endTime).getTime();
    var ref = (0,react.useState)("--"), minute = ref[0], setMinute = ref[1];
    var ref1 = (0,react.useState)("--"), second = ref1[0], setSecond = ref1[1];
    (0,react.useEffect)(function() {
        var distance = 0;
        var interval = setInterval(function() {
            var now = (0,app/* parseUtcTime */.Ec)();
            distance = countDownDate - now;
            setMinute((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60 * 60) / (1000 * 60))));
            setSecond((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60) / 1000)));
            if (Math.round(distance / 1000) < 1) {
                clearInterval(interval);
                handleCountDown && handleCountDown();
            // router.reload();
            }
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        countDownDate,
        endTime,
        handleCountDown
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "".concat(minute, ":").concat(second)
        })
    });
};

;// CONCATENATED MODULE: ./features/livestream/detail/partials/player/Lucky.tsx








var LuckyPartial = function(param) {
    var lucky = param.lucky, callRefetch = param.callRefetch;
    var ref = (0,react.useState)(null), dataOpenLucky = ref[0], setData = ref[1];
    // const [isCountdown, setShowCountDown] = useState<boolean>(isShow);
    var mutate = (0,api/* useOpenBoxLucky */.lh)({
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            if (data.id) {
                setData(data);
                callRefetch();
            }
        }
    }).mutate;
    var isCountdown = !!(lucky === null || lucky === void 0 ? void 0 : lucky.time_can_open_next_box) && new Date(lucky === null || lucky === void 0 ? void 0 : lucky.time_can_open_next_box).getTime() > (0,app/* parseUtcTime */.Ec)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-justify-center tw-flex-col tw-items-center tw-cursor-pointer tw-relative",
                onClick: function() {
                    return !isCountdown && mutate(lucky === null || lucky === void 0 ? void 0 : lucky.id);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                        className: "tw-w-10 tw-h-10",
                        src: isCountdown ? "/gift-f.gif" : "/icons8-gift.gif",
                        alt: "lucky gif"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-border tw-border-white tw-rounded-5 tw-px-2 tw-flex tw-justify-center tw-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            objectFit: "contain",
                            className: "tw-w-16 tw-h-5",
                            src: "/luck.png",
                            alt: "luck"
                        })
                    }),
                    isCountdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-white tw-text-xs tw-px-2 tw-bg-black tw-bg-opacity-70 tw-absolute tw-z-10 tw--bottom-7",
                            style: {
                                borderRadius: "3px",
                                paddingTop: "2px",
                                paddingBottom: "2px"
                            },
                            children: lucky && (lucky === null || lucky === void 0 ? void 0 : lucky.time_can_open_next_box) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown, {
                                endTime: lucky === null || lucky === void 0 ? void 0 : lucky.time_can_open_next_box,
                                handleCountDown: function() {
                                    return callRefetch();
                                }
                            })
                        })
                    })
                ]
            }),
            dataOpenLucky && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Modal */.u_, {
                className: "tw-p-0 tw-relative !tw-bg-transparent !tw-max-w-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* ModalBody */.fe, {
                        className: "tw-p-0 tw-relative tw-h-96 md:tw-h-164 tw-w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex tw-justify-center tw-items-center tw-w-11 tw-h-11 tw-absolute tw--right-5 tw--top-5 tw-rounded-full tw-border tw-border-red-500 tw-z-50 tw-cursor-pointer",
                                onClick: function() {
                                    return setData(null);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-flex tw-w-9 tw-h-9 tw-rounded-full tw-p-2 tw-bg-white tw-items-center tw-justify-center tw-text-red-500",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: "tw-w-full tw-h-full",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* XLineIcon */.pC, {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                className: "tw-w-full tw-h-full tw-rounded-10 tw-overflow-hidden",
                                src: dataOpenLucky === null || dataOpenLucky === void 0 ? void 0 : dataOpenLucky.attachment_url,
                                alt: "bg-lx",
                                objectFit: "cover"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalFooter */.mz, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                            className: "tw-w-full",
                            url: (dataOpenLucky === null || dataOpenLucky === void 0 ? void 0 : dataOpenLucky.attachment_url) || "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-full tw-py-2 tw-rounded-5 tw-bg-white tw-border-white !tw-text-secondary-70",
                                children: "Chia sẻ"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./contexts/profile/index.tsx
var contexts_profile = __webpack_require__(48309);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/lottery/list.tsx


var ListOfParticipants = function(props) {
    var participants = props.participants;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-flex tw-flex-col tw-gap-y-1 tw-h-auto tw-w-max",
        children: participants.length > 0 && participants.map(function(participant) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-bg-white tw-bg-opacity-40 md:tw-bg-opacity-25 tw-rounded-10 tw-px-2 tw-py-1 tw-w-24 md:tw-w-28 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-xs tw-w-full tw-text-secondary-70 md:tw-text-secondary-51 tw-line-clamp-1",
                        children: participant.fullName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-white tw-mt-0 md:tw-mt-1 tw-text-xs md:tw-text-13",
                        children: participant.number
                    })
                ]
            }, participant.number);
        })
    });
};

;// CONCATENATED MODULE: ./features/livestream/detail/partials/lottery/Confetti.tsx



var Confetti = function(param) {
    var title = param.title, wrapperClass = param.wrapperClass, key = param.key;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: wrapperClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-mr-2 tw-text-xs md:tw-text-13",
                children: title
            }),
            [
                1,
                2,
                3
            ].map(function(n) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                    src: "/confetti-flat.gif",
                    className: "tw-w-4 tw-h-4 md:tw-w-6 md:tw-h-6",
                    alt: "confetti"
                }, "".concat(key, "--").concat(n));
            })
        ]
    });
};
/* harmony default export */ var lottery_Confetti = (Confetti);

;// CONCATENATED MODULE: ./features/livestream/detail/partials/lottery/index.tsx








var LotteryPartial = function(props) {
    var t = props.t, gameId = props.gameId, showLotteryBtn = props.showLotteryBtn, messageData = props.messageData, gameStatus = props.gameStatus, isAuth = props.isAuth, liveStreamId = props.liveStreamId;
    var ref = (0,react.useState)([]), participants = ref[0], setParticipants = ref[1];
    var ref1 = (0,react.useState)(gameStatus), status = ref1[0], setStatus = ref1[1];
    var ref2 = (0,react.useState)(gameStatus === shared/* LotteryGameStatus.Pending */.Ck.Pending ? shared/* LotteryTicketStatus.Pending */.Jz.Pending : shared/* LotteryTicketStatus.CloseList */.Jz.CloseList), ticketStatus = ref2[0], setTicketStatus = ref2[1];
    var ref3 = (0,react.useState)(0), countUser = ref3[0], setCountUser = ref3[1];
    var ref4 = (0,api/* useListOfParticipantsQuery */.pC)({
        lottery_game_id: gameId,
        offset: 0,
        limit: 5,
        status: ticketStatus
    }, {
        enabled: false,
        retry: false,
        onSuccess: function(param) {
            var data = param.data, total_records = param.total_records;
            if (!data) {
                setCountUser(0);
                return setParticipants([]);
            }
            var _p = data.sort(function(a, b) {
                return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
            }).map(function(d) {
                return {
                    number: d.number,
                    fullName: d.users.fullname
                };
            });
            setCountUser(total_records);
            setParticipants(_p);
        }
    }), refetchParticipants = ref4.refetch;
    (0,react.useEffect)(function() {
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* LotterySocketMethod.UserConfirmTicket */.Sf.UserConfirmTicket) {
            var ref, ref1, ref2;
            var _p = {
                number: ((ref = messageData.data) === null || ref === void 0 ? void 0 : ref.number) || 0,
                fullName: ((ref1 = messageData.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.users) === null || ref2 === void 0 ? void 0 : ref2.fullname) || ""
            };
            setCountUser(function(prev) {
                return prev + 1;
            });
            setParticipants(function(prev) {
                if (prev.length > 4) {
                    return (0,_to_consumable_array/* default */.Z)(prev.slice(0, 4)).concat([
                        _p
                    ]);
                }
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    _p
                ]);
            });
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* LotterySocketMethod.OpenLottery */.Sf.OpenLottery) {
            setTicketStatus(shared/* LotteryTicketStatus.Pending */.Jz.Pending);
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* LotterySocketMethod.CloseListLottery */.Sf.CloseListLottery) {
            setStatus(shared/* LotteryGameStatus.Starting */.Ck.Starting);
            setTicketStatus(shared/* LotteryTicketStatus.CloseList */.Jz.CloseList);
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* LotterySocketMethod.AdminPickTicketLottery */.Sf.AdminPickTicketLottery) {
            setStatus(shared/* LotteryGameStatus.Ended */.Ck.Ended);
        }
    }, [
        messageData
    ]);
    (0,react.useEffect)(function() {
        if (gameId) refetchParticipants();
    }, [
        liveStreamId,
        gameId,
        refetchParticipants,
        ticketStatus
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-center tw-w-max tw-cursor-pointer",
                onClick: isAuth ? showLotteryBtn : function() {},
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                        src: "/confetti-flat.gif",
                        className: "tw-w-10 tw-h-10 md:tw-w-16 md:tw-h-16",
                        alt: "confetti"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-border tw-rounded-5 tw-border-white tw-w-12 tw-h-4 md:tw-w-20 md:tw-h-5 tw-flex tw-items-center tw-justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            src: "/lottery.svg",
                            className: "tw-w-6 tw-h-3 md:tw-w-10 md:tw-h-5",
                            alt: "lottery",
                            objectFit: "contain"
                        })
                    })
                ]
            }),
            status === shared/* LotteryGameStatus.Pending */.Ck.Pending && /*#__PURE__*/ (0,jsx_runtime.jsx)(lottery_Confetti, {
                wrapperClass: "tw-mt-2 tw-pt-1 md:tw-mt-3 tw-bg-black tw-bg-opacity-30 tw-text-white tw-rounded-full tw-px-2 md:tw-px-3 tw-pb-1 tw-flex tw-items-end",
                title: t("detail.label.start-lottery")
            }, "pending"),
            countUser > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-mt-2 tw-text-xs md:tw-text-13 tw-text-white",
                children: [
                    countUser,
                    " ",
                    t("detail.label.user-join")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mt-3 md:tw-mt-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListOfParticipants, {
                    participants: participants
                })
            }),
            status === shared/* LotteryGameStatus.Starting */.Ck.Starting && /*#__PURE__*/ (0,jsx_runtime.jsx)(lottery_Confetti, {
                wrapperClass: "tw-mt-1 md:tw-mt-3 tw-bg-black tw-bg-opacity-30 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-flex tw-items-end",
                title: t("detail.label.end-list")
            }, "starting")
        ]
    });
};

;// CONCATENATED MODULE: ./features/livestream/detail/partials/player/AuctionCountDown.tsx



var AuctionCountDown = function(param) {
    var endTime = param.endTime, showCountDown = param.showCountDown;
    var countDownDate = new Date(endTime).getTime();
    var ref = (0,react.useState)(true), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)("0"), hours = ref1[0], setHours = ref1[1];
    var ref2 = (0,react.useState)("0"), minute = ref2[0], setMinute = ref2[1];
    var ref3 = (0,react.useState)("0"), second = ref3[0], setSecond = ref3[1];
    (0,react.useEffect)(function() {
        var distance = 0;
        var interval = setInterval(function() {
            var now = (0,app/* parseUtcTime */.Ec)();
            distance = countDownDate - now;
            setHours((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60))));
            setMinute((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60 * 60) / (1000 * 60))));
            setSecond((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60) / 1000)));
            if (Math.round(distance / 1000) === 1) {
                setShow(false);
                clearInterval(interval);
                showCountDown && showCountDown();
            // router.reload();
            }
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        endTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-text-white tw-flex tw-items-center tw-gap-x-1 tw-text-26 tw-font-semibold",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " tw-text-white tw-flex tw-items-center tw-justify-center tw-w-[40px]",
                        children: hours
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: ":"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " tw-text-white tw-flex tw-items-center tw-justify-center tw-w-[40px] ",
                        children: minute
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: ":"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " tw-text-white tw-flex tw-items-center tw-justify-center tw-w-[40px]",
                        children: second
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var player_AuctionCountDown = (AuctionCountDown);

;// CONCATENATED MODULE: ./features/livestream/detail/partials/player/index.tsx
/* eslint-disable @next/next/no-img-element */ 















var PlayerPartial = function(param) {
    var url = param.url, productsRange = param.productsRange, pinnedProduct = param.pinnedProduct, setPinnedProduct = param.setPinnedProduct, liveStreamId = param.liveStreamId, liveStatus = param.liveStatus, t = param.t, lotteryGame = param.lotteryGame, isAuth = param.isAuth, sticker = param.sticker, messageData = param.messageData, showLotteryBtn = param.showLotteryBtn, hideLotteryBtn = param.hideLotteryBtn, luckyDetail = param.luckyDetail;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router.useRouter)();
    var profile = (0,contexts_profile/* useProfile */.Un)();
    var ref7 = (0,api/* useWatchVideoQuery */.Ll)(), mutateWatchVideo = ref7.mutate;
    var ref8 = (0,api/* useEndWatchVideoQuery */.B4)(), mutateEndWatchVideo = ref8.mutate;
    var ref9 = (0,react.useState)(false), isVideoError = ref9[0], setVideoError = ref9[1];
    var ref10 = (0,react.useState)(""), videoHeight = ref10[0], setVideoHeight = ref10[1];
    var ref11 = (0,react.useState)(null), lucky = ref11[0], setLucky = ref11[1];
    var ref12 = (0,react.useState)(null), gameId = ref12[0], setGameId = ref12[1];
    var ref13 = (0,react.useState)((lotteryGame === null || lotteryGame === void 0 ? void 0 : lotteryGame.status) || shared/* LotteryGameStatus.Ended */.Ck.Ended), gameStatus = ref13[0], setGameStatus = ref13[1];
    var refDiv = (0,react.useRef)(null);
    var playerRef = (0,react.useRef)(null);
    var gameRef = (0,react.useRef)(null);
    var start = router.query.start ? parseInt(router.query.start + "") : 0;
    console.log(luckyDetail);
    (0,react.useEffect)(function() {
        setGameId((lotteryGame === null || lotteryGame === void 0 ? void 0 : lotteryGame.id) || null);
    }, [
        lotteryGame === null || lotteryGame === void 0 ? void 0 : lotteryGame.id
    ]);
    (0,react.useEffect)(function() {
        setLucky(luckyDetail);
    }, [
        liveStreamId,
        luckyDetail
    ]);
    (0,react.useEffect)(function() {
        if (isAuth) mutateWatchVideo({});
    }, [
        isAuth,
        mutateWatchVideo
    ]);
    var ref14 = (0,api/* useFetchLuckyBuyLiveIdQuery */.mZ)(liveStreamId, {
        enabled: false,
        retry: false,
        onSuccess: function(param) {
            var data = param.data;
            if (data.status === shared/* LuckyStatus.PROCESSING */.oj.PROCESSING) setLucky(data);
        },
        onError: function() {
            setLucky(null);
        }
    }), refetchLucky = ref14.refetch;
    (0,react.useEffect)(function() {
        var handleTabClose = function(event) {
            event.preventDefault();
            if (isAuth) mutateEndWatchVideo({
                enable: false
            });
        };
        window.addEventListener("beforeunload", handleTabClose);
        return function() {
            window.removeEventListener("beforeunload", handleTabClose);
        };
    }, [
        isAuth,
        mutateEndWatchVideo
    ]);
    var onVideoPlaying = function(param) {
        var currentPlayedSecond = param.playedSeconds, played = param.played;
        if (liveStatus !== detail_const/* LiveStreamStatus.LIVE_NOW */.zN.LIVE_NOW) {
            var currentProductRange = productsRange.find(function(param) {
                var range = param.range;
                var _range = (0,_sliced_to_array/* default */.Z)(range, 2), rangeStart = _range[0], rangeEnd = _range[1];
                return rangeStart <= currentPlayedSecond && rangeEnd >= currentPlayedSecond;
            });
            if (currentProductRange) {
                var product = currentProductRange.product;
                var currentProductId = product.product_id;
                if (currentProductId !== (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id) && product.products.status !== shared/* ProductStatus.Hide */.Pt.Hide) {
                    setPinnedProduct(product);
                }
            }
        }
    };
    (0,react.useEffect)(function() {
        setVideoError(false);
    }, [
        url
    ]);
    (0,react.useEffect)(function() {
        if (refDiv) {
            var ref;
            setVideoHeight(refDiv === null || refDiv === void 0 ? void 0 : (ref = refDiv.current) === null || ref === void 0 ? void 0 : ref.clientHeight);
        }
    }, []);
    var handleOnError = function(data) {
        setVideoError(data.isTrusted);
    };
    var playerConfig = {
        attributes: {
            height: videoHeight
        }
    };
    var endGame = function() {
        if (gameRef.current) clearTimeout(gameRef.current);
        gameRef.current = setTimeout(function() {
            setGameId(null);
            hideLotteryBtn();
            setGameStatus(shared/* LotteryGameStatus.Ended */.Ck.Ended);
        }, 10000);
    };
    (0,react.useEffect)(function() {
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* CommentMethod.ProcessingLucky */.iz.ProcessingLucky) {
            if (!messageData.data) return;
            setLucky(messageData.data);
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* CommentMethod.FinishLucky */.iz.FinishLucky) setLucky(null);
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* LotterySocketMethod.OpenLottery */.Sf.OpenLottery) {
            var ref;
            setGameStatus(shared/* LotteryGameStatus.Pending */.Ck.Pending);
            setGameId(((ref = messageData.data) === null || ref === void 0 ? void 0 : ref.lottery_game_id) || "");
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* LotterySocketMethod.EndLottery */.Sf.EndLottery) {
            endGame();
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* LiveProductMethod.PinProduct */.zN.PinProduct) {
            var p = messageData.data.live_stream_product;
            if (p && p.product_id !== (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id)) {
                setPinnedProduct(p);
            }
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* LiveProductMethod.AuctionStarted */.zN.AuctionStarted || (messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* LiveProductMethod.AuctionEnded */.zN.AuctionEnded) {
            if (!messageData.data) return;
            setPinnedProduct(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    products: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.products), {
                        auction: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.products.auction), {
                            ended_time_at: messageData.data.ended_time_at,
                            started_at: messageData.data.started_at,
                            status: messageData.data.status
                        })
                    })
                });
            });
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === shared/* LiveProductMethod.AuctionOffer */.zN.AuctionOffer) {
            setPinnedProduct(function(prev) {
                if (!messageData.data) return;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    products: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.products), {
                        auction: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.products.auction), {
                            sell_price: messageData.data.sell_price || 0
                        })
                    })
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        messageData
    ]);
    var renderLucky = function(type) {
        if (!type) return "";
        if (type == shared/* EventType.Gift */.tw.Gift) return "Qu\xe0 tặng";
        if (type == shared/* EventType.Wishes */.tw.Wishes) return "Lời ch\xfac";
        if (type == shared/* EventType.Voucher */.tw.Voucher) return "Voucher";
    };
    var checkMyAccount = function(type, userId) {
        if (type === shared/* EventType.Wishes */.tw.Wishes && userId === (profile === null || profile === void 0 ? void 0 : profile.id)) return false;
        return true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-h-full tw-w-full tw-relative",
            style: {
                minHeight: "450px"
            },
            ref: refDiv,
            children: [
                isVideoError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-justify-center tw-items-center tw-h-full",
                    children: t("detail.error")
                }),
                !isVideoError && videoHeight !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                    url: url,
                    width: "100%",
                    height: "100%",
                    className: "react-player",
                    style: {
                        textAlign: "center",
                        backgroundColor: "black"
                    },
                    ref: playerRef,
                    autoPlay: true,
                    muted: true,
                    playing: true,
                    controls: true,
                    onReady: function() {
                        var ref;
                        return (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.seekTo(start, "seconds");
                    },
                    onProgress: onVideoPlaying,
                    onError: handleOnError,
                    config: playerConfig,
                    onStart: function() {
                        return console.log("start");
                    },
                    onEnded: function() {
                        return console.log("end");
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                    children: lucky && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        className: "tw-absolute tw-right-4 tw-bottom-20 tw-z-10",
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 1
                        },
                        exit: {
                            opacity: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LuckyPartial, {
                            lucky: lucky,
                            callRefetch: function() {
                                return refetchLucky();
                            }
                        })
                    })
                }),
                gameId && gameStatus !== shared/* LotteryGameStatus.Ended */.Ck.Ended && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute tw-left-2 tw-top-4 md:tw-left-6 md:tw-top-16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryPartial, {
                        isAuth: isAuth,
                        t: t,
                        gameId: gameId,
                        liveStreamId: liveStreamId,
                        messageData: messageData,
                        showLotteryBtn: showLotteryBtn,
                        gameStatus: gameStatus
                    })
                }),
                ((ref = pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.auction) === null || ref === void 0 ? void 0 : ref.status) === shared/* AuctionStatus.Started */.wo.Started && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute tw-right-2 tw-top-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(player_AuctionCountDown, {
                        endTime: pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.auction.ended_time_at
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bubbling-heart tw-w-full tw-h-full tw-z-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: sticker && [
                            1,
                            2,
                            3,
                            4
                        ].map(function(i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                className: "tw-w-7 tw-h-7 tw-rounded-full",
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: sticker,
                                    className: "tw-w-full tw-h-full",
                                    alt: sticker
                                })
                            }, i);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-absolute tw-left-2 tw-bottom-3 tw-gap-y-2 tw-flex tw-flex-col",
                    children: [
                        !!messageData && messageData.method === shared/* LotterySocketMethod.AdminPickTicketLottery */.Sf.AdminPickTicketLottery && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                className: "tw-bg-black tw-bg-opacity-30 tw-rounded-full tw-px-4 tw-py-1 tw-text-white tw-flex tw-items-center tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "Kết quả xổ số: ",
                                            messageData.data.number
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: "/confetti-flat.gif",
                                        alt: "confetti",
                                        className: "tw-w-6 tw-h-6 tw-ml-1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: "/confetti-flat.gif",
                                        alt: "confetti",
                                        className: "tw-w-6 tw-h-6 tw-ml-1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: "/confetti-flat.gif",
                                        alt: "confetti",
                                        className: "tw-w-6 tw-h-6 tw-ml-1"
                                    })
                                ]
                            })
                        }),
                        !!messageData && messageData.method === shared/* CommentMethod.OpenLuckyBox */.iz.OpenLuckyBox && checkMyAccount(messageData === null || messageData === void 0 ? void 0 : messageData.data.type, (ref1 = messageData.data.users) === null || ref1 === void 0 ? void 0 : ref1.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                className: "tw-bg-black tw-bg-opacity-30 tw-rounded-full tw-px-4 tw-py-1 tw-text-white tw-flex tw-items-center tw-text-base",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        messageData === null || messageData === void 0 ? void 0 : (ref2 = messageData.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.users) === null || ref3 === void 0 ? void 0 : ref3.fullname,
                                        " đ\xe3 mở được\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: renderLucky(messageData.data.type)
                                        })
                                    ]
                                })
                            })
                        }),
                        !!messageData && messageData.method === shared/* MessageMethodType.Sticker */.eu.Sticker && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                className: "tw-bg-black tw-bg-opacity-30 tw-rounded-full tw-px-4 tw-py-1 tw-text-white tw-flex tw-items-center tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            messageData.data.fullname,
                                            " đ\xe3 tặng \xa0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        alt: messageData === null || messageData === void 0 ? void 0 : (ref4 = messageData.data) === null || ref4 === void 0 ? void 0 : ref4.sticker_icon,
                                        src: messageData === null || messageData === void 0 ? void 0 : (ref5 = messageData.data) === null || ref5 === void 0 ? void 0 : ref5.sticker_icon,
                                        className: "tw-w-6 tw-h-6 tw-rounded-full",
                                        objectFit: "cover"
                                    })
                                ]
                            })
                        }),
                        !!messageData && messageData.method === shared/* MessageMethodType.JoinLivestream */.eu.JoinLivestream && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                className: "tw-px-4 tw-py-1 tw-text-white tw-flex tw-items-center tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            messageData.data.fullname,
                                            " đ\xe3 tham gia \xa0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: "tw-flex tw-items-center tw-justify-center",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WaveIcon */.Lk, {})
                                    })
                                ]
                            })
                        }),
                        !!messageData && messageData.method === shared/* MessageMethodType.GiftAtd */.eu.GiftAtd && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                className: "tw-px-4 tw-py-1 tw-text-white tw-flex tw-items-center tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            (ref6 = messageData.data.users) === null || ref6 === void 0 ? void 0 : ref6.fullname,
                                            " đ\xe3 tặng"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: "/diamond-kam.png",
                                        alt: "diamond",
                                        className: "tw-w-4 tw-h-4 tw-mx-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-text-white tw-font-bold",
                                        children: [
                                            messageData.data.amount,
                                            " ATD"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                liveStatus === detail_const/* LiveStreamStatus.LIVE_NOW */.zN.LIVE_NOW && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-absolute tw-left-6 tw-top-[60px] tw-flex tw-items-center tw-px-4 tw-bg-red-600 tw-text-white tw-font-xs tw-rounded tw-mr-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-white tw-mr-1 tw-block"
                        }),
                        "Live"
                    ]
                })
            ]
        })
    });
};
PlayerPartial.defaultProps = {
    products: [],
    prevPlayedSeconds: 0
};
/* harmony default export */ var player = (PlayerPartial);


/***/ }),

/***/ 53154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getCommentAuthor; },
/* harmony export */   "g": function() { return /* binding */ productsRangeBuilder; }
/* harmony export */ });
var productsRangeBuilder = function(products) {
    if (!Array.isArray(products)) {
        return [];
    }
    var arr = [];
    var p = products.sort(function(a, b) {
        return a.played - b.played;
    });
    for(var i = 0; i < p.length; i++){
        var ref = p[i + 1] || {}, nextRangeStartSecond = ref.played;
        var _i = p[i], rangeStartSecond = _i.played;
        var rangeEndSecond = 86400;
        if (nextRangeStartSecond) {
            rangeEndSecond = nextRangeStartSecond;
        }
        arr.push({
            product: p[i],
            range: [
                rangeStartSecond,
                rangeEndSecond
            ]
        });
    }
    return arr;
};
var getCommentAuthor = function(user, staff) {
    if (!user && !staff) return {
        avatar: "/logo-mini.jpeg",
        fullname: "#"
    };
    var author = user || staff;
    if (author) {
        var avatar = author.avatar, fullname = author.fullname;
        return {
            avatar: avatar,
            fullname: fullname
        };
    }
    return {
        avatar: "",
        fullname: "#"
    };
};


/***/ }),

/***/ 17852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mM": function() { return /* binding */ useRemindResellQuery; },
/* harmony export */   "uJ": function() { return /* binding */ useCreateChatConversation; },
/* harmony export */   "uK": function() { return /* binding */ useFetchConversationByProductQuery; }
/* harmony export */ });
/* unused harmony exports fetchProduct, fetchProductAuth, fetchConversationByProduct, createConversation, fetchAccountProfile, useFetchUserQuery, RemindResell */
/* harmony import */ var _libs_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80787);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7806);



var fetchProduct = function(id) {
    return axios.get("/api/v1/products/".concat(id));
};
var fetchProductAuth = function(id, token) {
    return axios.get("/api/v1/products/".concat(id), {
        headers: {
            Authorization: "Bearer ".concat(token)
        }
    });
};
var fetchConversationByProduct = function(id) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_0__/* .AxiosChatInstance.get */ .WA.get("/v2/me/chat/conversations/type/product/".concat(id));
};
var createConversation = function(payload) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_0__/* .AxiosChatInstance.post */ .WA.post("/v2/me/chat/conversations", payload);
};
var useCreateChatConversation = function(options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(function(payload) {
        return createConversation(payload);
    }, options);
};
var useFetchConversationByProductQuery = function(id, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.Conversations */ .S8.Conversations,
        id
    ], function() {
        return fetchConversationByProduct(id);
    }, options);
};
var fetchAccountProfile = function() {
    return axios.get("/api/v1/user/profile");
};
var useFetchUserQuery = function(options) {
    return useQuery([
        QueryKey.Users
    ], function() {
        return fetchAccountProfile();
    }, options);
};
var RemindResell = function(payload) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/api/v1/products/remind/resell", payload);
};
var useRemindResellQuery = function(options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(function(payload) {
        return RemindResell(payload);
    }, options);
};


/***/ })

}]);